/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('change-password', require('./components/ChangePassword.vue').default);
Vue.component('create-permission', require('./components/CreatePermission.vue').default);
Vue.component('transaction-categories', require('./components/TransactionCategories.vue').default);
Vue.component('projects-component', require('./components/Projects.vue').default);
Vue.component('project-autocomplete', require('./components/ProjectAutocomplete.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import axios from "axios";
Vue.prototype.$Laravel = window.Laravel;

axios.defaults.headers.common = {
    Authorization: "Bearer " + window.Laravel.token,
    Accept: "application/json",
}

const app = new Vue({
    el: '#app',
});

import { Tooltip } from 'bootstrap';

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl)
});
